import React from 'react'
import { List, Title } from './styles'

type Props = {
  'data-qa'?: string
  title?: string
  rows: (JSX.Element | string)[]
}

const CompactList: React.FC<Props> = (props: Props): JSX.Element => {
  return (
    <List data-qa={props['data-qa']}>
      {props.title && <Title>{props.title}</Title>}
      <ul>
        {props.rows.map((row, key) => (
          <li
            key={key}
            data-qa={props['data-qa'] && `${props['data-qa']}-row-${key}`}
          >
            {row}
          </li>
        ))}
      </ul>
    </List>
  )
}

export default CompactList
